import { GET_LANGUAGE_SUCCESS, TOGGLE_THEME_MODE, CHANGE_THEME_MODE } from "./constants";

// Function to detect the system theme
// Returns "dark" if the system theme is dark, otherwise returns "light"
const detectSystemTheme = () => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

// Retrieve the stored theme from localStorage, default to "system" if not set
const storedTheme = localStorage.getItem("theme") || "system";

// Determine the initial theme based on the stored theme or system preference
const initialTheme = storedTheme === "system" ? detectSystemTheme() : storedTheme;

// Define the initial state of the reducer
const initialState = {
  language: "en",
  themeMode: initialTheme,
};

// Reducer function to handle language and theme changes
const languageReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LANGUAGE_SUCCESS: {
      return {
        ...state,
        language: payload,
      };
    }
    case TOGGLE_THEME_MODE: {
      // Handle theme mode toggle action
      const newThemeMode = state.themeMode === "light" ? "dark" : "light";
      localStorage.setItem("theme", newThemeMode);
      return {
        ...state,
        themeMode: newThemeMode,
      };
    }
    case CHANGE_THEME_MODE: {
      const newThemeMode = payload === "system" ? detectSystemTheme() : payload; // Determine new theme mode
      localStorage.setItem("theme", payload); // Save the new theme preference to localStorage
      return {
        ...state,
        themeMode: newThemeMode,
      };
    }
    default:
      return state;
  }
};

export default languageReducer;
